<template>
  <div class="club_merge">
    <page-header :title="$t('club.merge')">
    </page-header>
    <page-content>
      <div class="row">
        <div v-for="type in ['original', 'copy']" :key="type" class="col-sm-6">
          <ntm-block :title="$t(type)" class="pb-4">
            <v-select @search="(search, loading) => searchClub(search, loading, type)"
                      :filter="(options) => options"
                      v-model="selectedClub[type]" :options="filteredOptions(type)"
                      :inputId="'club-' + type + '-search'" label="name"
                      :data-testid="'club-merge-' + type"
                      :placeholder="$t('club.searchAndAdd')">
              <template #option="option">
                {{ option.name }}<span v-if="option.shortName"> ({{ option.shortName }})</span>
              </template>
              <template #no-options>
                <p class="info">{{ $t('club.searchAndAdd') }}</p>
              </template>
            </v-select>
          </ntm-block>
          <ntm-block>
            <div class="text-center" style="margin-bottom: 20px" :data-testid="'club-merge-' + type + '-card'">
              <h3>{{ selectedClub[type] ? selectedClub[type].name : $t('club.select') }}</h3>
              <h5 v-if="selectedClub[type]">{{ selectedClub[type].shortName }}</h5>
            </div>
          </ntm-block>
        </div>
        <div v-if="selectedClub.original && selectedClub.copy" class="col-sm-12 text-center">
          <button :disabled="loading" @click="mergeClubs()" class="btn btn-warning" data-testid="club-merge-submit">
            <i v-if="loading" class="fa fa-cog fa-spin"></i> {{ $t('club.merge') }}
          </button>
        </div>
      </div>
    </page-content>
  </div>
</template>
<script>
import _ from 'lodash'
import ClubService from '@/services/club.service'
import VueI18n from '@/i18n'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      loading: false,
      clubOptions: {
        original: [],
        copy: []
      },
      selectedClub: {
        original: null,
        copy: null
      }
    }
  },
  methods: {
    searchClub (search, loading, type) {
      if (search.length > 0) {
        loading(true)
        this.searchClubs(search, loading, type)
      } else {
        this.clubOptions[type] = []
      }
    },
    searchClubs: _.debounce(function (search, loading, type) {
      ClubService.index(search).then((res) => {
        this.clubOptions[type] = res.data.data
        loading(false)
      })
    }, 300),
    filteredOptions (type) {
      const other = this.selectedClub[type === 'original' ? 'copy' : 'original']

      return this.clubOptions[type].filter((club) => !other || club.uuid !== other.uuid)
    },
    mergeClubs () {
      return Swal.fire({
        title: VueI18n.t('swal.mergeClubs.title'),
        text: VueI18n.t('swal.mergeClubs.text'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: VueI18n.t('swal.mergeClubs.yes'),
        cancelButtonText: VueI18n.t('swal.mergeClubs.no'),
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          this.loading = true
          return ClubService.merge(this.selectedClub).then((res) => {
            this.selectedClub.copy = null
            this.clubOptions.copy = []
            this.$store.commit('loaded')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
